module.exports = __webpack_public_path__ + "static/4-218f4462630c9e6a5c36fd279fe11ccf.jpg";